var map = {
	"./bit_burst/manifest.json": 2193,
	"./core_striker/manifest.json": 1825,
	"./mem_link/manifest.json": 139,
	"./snake/manifest.json": 2579,
	"./tetromo/manifest.json": 4037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9188;